var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55152 11.4136L7.42427 12.2864L9.48147 10.2417L9.48147 18.084L10.7283 18.084L10.7283 10.2417L12.7855 12.2864L13.6582 11.4136L10.1049 7.8478L6.55152 11.4136Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24755 9.98047L3.24755 3.74654L16.9622 3.74654L16.9622 9.98047L18.209 9.98047L18.209 2.49975L2.00076 2.49975L2.00076 9.98047L3.24755 9.98047Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.4e19f3eff88e00440cffe3a1cf171eb2.svg";
export { ForwardRef as ReactComponent };